<template>
  <div>
    <h2>ASCA Reports</h2>
    <div class="e-card" id="basic">
      <div class="e-card-content">
        <ejs-tab class="e-background">
          <e-tabitems>
            <e-tabitem :header="headerText0" :content="content0" />
            <e-tabitem :header="headerText1" :content="content1" />
            <e-tabitem :header="headerText2" :content="content2" />
            <e-tabitem :header="headerText3" :content="content3" />
            <e-tabitem :header="headerText4" :content="content4" />
            <e-tabitem :header="headerText5" :content="content5" />
          </e-tabitems>
        </ejs-tab>
      </div>
    </div>
    <div id="accountingReports">
      <accounting-reports />
    </div>
    <div id="sitesOnHold" style="display: none">
      <sites-on-hold />
    </div>
    <div id="workPermits" style="display: none">
      <work-permits />
    </div>
    <div id="autoEmails" style="display: none">
      <auto-emails />
    </div>
    <div id="operatingPermits" style="display: none">
      <operating-permits />
    </div>
    <div id="inspections" style="display: none">
      <inspections />
    </div>
     <div id="searchRequestApplications" style="display: none">
      <search-request-applications />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
import sitesOnHold from '../components/sites-on-hold.vue';
import workPermits from '../components/work-permits.vue';
import autoEmails from '../components/auto-emails.vue';
import operatingPermits from '../components/operating-permits.vue';
import inspections from '../components/inspections.vue';
import searchRequestApplications from '../components/search-request-applications.vue';
import accountingReports from '../components/accounting-reports.vue';

Vue.use(TabPlugin);

export default {
  components: {
    accountingReports,
    sitesOnHold,
    workPermits,
    autoEmails,
    operatingPermits,
    inspections,
    searchRequestApplications,
  },
  data() {
    return {
      headerText0: { text: ' Accounting Reports ' },
      headerText1: { text: ' Sites On Hold ' },
      headerText2: { text: ' Work Permits ' },
      headerText3: { text: ' Auto Emails ' },
      headerText4: { text: ' Operating Permits' },
      headerText5: { text: ' Inspections' },
      headerText6: { text: ' Search Request Applications' },
      content0: '#accountingReports',
      content1: '#sitesOnHold',
      content2: '#workPermits',
      content3: '#autoEmails',
      content4: '#operatingPermits',
      content5: '#inspections',
      content6: '#searchRequestApplications',
    };
  },
};
</script>
